module.exports = __webpack_public_path__ + "img/shagbark_the_plush.483bdab6.png";